module.exports = __webpack_public_path__ + "media/images/platforms/ea-id/connect-943d5dd322b733107360a48d1fac1992.png";